import type { EntregaDoPedido } from "@bookdental/schemas";
import { formatCep } from "@/lib/viacep";

/** As colunas `entrega*` do pedido, como vêm da API. */
export type ColunasDeEntrega = {
  entregaDestinatario?: string | null;
  entregaTelefone?: string | null;
  entregaCep?: string | null;
  entregaEndereco?: string | null;
  entregaNumero?: string | null;
  entregaComplemento?: string | null;
  entregaBairro?: string | null;
  entregaCidade?: string | null;
  entregaUf?: string | null;
};

/** O endereço de entrega do pedido, ou `null` se ele foi criado sem endereço nenhum. */
export function entregaDoPedido(o: ColunasDeEntrega): EntregaDoPedido | null {
  if (!o.entregaEndereco && !o.entregaCep) return null;
  return {
    destinatario: o.entregaDestinatario ?? "",
    telefone: o.entregaTelefone ?? "",
    cep: o.entregaCep ?? "",
    endereco: o.entregaEndereco ?? "",
    numero: o.entregaNumero ?? "",
    complemento: o.entregaComplemento ?? "",
    bairro: o.entregaBairro ?? "",
    cidade: o.entregaCidade ?? "",
    uf: (o.entregaUf ?? "SP") as EntregaDoPedido["uf"],
  };
}

/** Uma linha, pra mostrar na tela. */
export function formatarEndereco(e: EntregaDoPedido): string {
  const rua = [e.endereco, e.numero].filter(Boolean).join(", ");
  const complemento = e.complemento ? ` — ${e.complemento}` : "";
  return `${rua}${complemento} · ${e.bairro} · ${e.cidade}/${e.uf} · CEP ${formatCep(e.cep)}`;
}

/** Bloco de etiqueta (várias linhas), pra copiar e colar no site da transportadora. */
export function enderecoParaEtiqueta(e: EntregaDoPedido): string {
  return [
    e.destinatario,
    [e.endereco, e.numero].filter(Boolean).join(", ") + (e.complemento ? ` — ${e.complemento}` : ""),
    e.bairro,
    `${e.cidade}/${e.uf}`,
    `CEP ${formatCep(e.cep)}`,
    e.telefone ? `Tel. ${e.telefone}` : null,
  ]
    .filter(Boolean)
    .join("\n");
}
